

























































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import CheckBox from './components/CheckBox/index.vue'
import ChevronIcon from '@/app/ui/assets/chevron_down.vue'
import CloseLine from '@/app/ui/assets/close_line.vue'

export interface AddressOption {
  value: number
  name?: string
  picName?: string
  phoneNumber?: string
  address?: string
  latlon?: string
}

@Component({
  components: { CheckBox, ChevronIcon, CloseLine },
})
export default class MarketplaceAddressSelect extends Vue {
  @Prop({ required: true }) private fieldLabel!: string
  @Prop({ default: false }) private required!: boolean
  @Prop({ default: false }) private disabled!: boolean
  @Prop({ default: false }) private loading!: boolean
  @Prop({ default: false }) private isError!: boolean
  @Prop({ default: 'Pilih alamat' }) private placeholder!: string
  @Prop() private errorMessage!: string
  @Prop({ default: () => [] }) private options!: AddressOption[]
  // Selected option values (pca_id)
  @Prop({ default: () => [] }) private value!: number[]

  isOpen = false

  get selectedCount(): number {
    return this.value.length
  }

  get isAllSelected(): boolean {
    return (
      this.options.length > 0 &&
      this.options.every(option => this.isSelected(option.value))
    )
  }

  get isPartiallySelected(): boolean {
    return this.selectedCount > 0 && !this.isAllSelected
  }

  get selectedOptions(): AddressOption[] {
    const map = new Map<number, AddressOption>()
    this.options.forEach(opt => map.set(opt.value, opt))
    return this.value.map(
      val => map.get(val) || { value: val, name: String(val) }
    )
  }

  get displayedChips(): AddressOption[] {
    return this.selectedOptions.slice(0, 3)
  }

  get remainingCount(): number {
    return Math.max(0, this.selectedCount - 3)
  }

  get headerText(): string {
    if (!this.selectedCount) return this.placeholder
    if (this.isAllSelected) return `Pilih semua (${this.options.length} Alamat)`
    return `${this.selectedCount} alamat dipilih`
  }

  @Watch('disabled')
  private onDisabledChange(disabled: boolean): void {
    if (disabled) this.close()
  }

  private isSelected(value: number): boolean {
    return this.value.includes(value)
  }

  private toggleOpen(): void {
    if (this.disabled) return
    this.isOpen = !this.isOpen
  }

  private close(): void {
    this.isOpen = false
  }

  private toggleOne(value: number): void {
    const next = this.isSelected(value)
      ? this.value.filter(item => item !== value)
      : [...this.value, value]
    this.$emit('input', next)
  }

  private removeOne(value: number): void {
    if (this.disabled) return
    const next = this.value.filter(item => item !== value)
    this.$emit('input', next)
  }

  private removeRemaining(): void {
    if (this.disabled) return
    const keep = this.displayedChips.map(option => option.value)
    this.$emit('input', keep)
  }

  // Select / deselect the whole eligible dataset
  private toggleAll(): void {
    this.$emit(
      'input',
      this.isAllSelected ? [] : this.options.map(option => option.value)
    )
  }
}
